import React from 'react';
import { JsonUploadForm } from '../dialogs/components/json-upload-form';
import { GlobalVariables } from '../../GlobalVariables';
import { formatDate } from './elements/Forms/DateTimeInput';
import Reload from './icons/Reload';
import { useSelector } from 'react-redux';
import { lastTransactionDateReloadingState } from '../../redux/slices/statusesSlice';
import { lastTransactionDateState } from '../../redux/slices/tsSlice';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
import { ApiCalls } from '../../ApiCalls';

const UploadContent = () => {
    const isLastTransactionDateReloading = useSelector(lastTransactionDateReloadingState);
    const lastTransactionDateUpdatedTS = useSelector(lastTransactionDateState);

    React.useEffect(() => {
        console.log('lastTransactionDateUpdatedTS', lastTransactionDateUpdatedTS);
        ReduxUpdater.lastTransactionDateReloading = true;
        ApiCalls.lastTransaction().then(d => {
            console.log('lastTransactionDateUpdatedTS ENDED!!!');
            ReduxUpdater.lastTransactionDateReloading = false;
            GlobalVariables.lastTransactionDate = d;
        }).catch(err => console.error(err));
    }, [lastTransactionDateUpdatedTS]);

    return (
        <div className="w-[1000px] px-4 inline-flex flex-col justify-center items-start gap-6 fill-available">
            <span className="mx-auto text-xl font-bold">Most recent (extracted) POS transaction date: {isLastTransactionDateReloading ? <div className="w-4 h-4 animate-spin inline-flex"><Reload height={16}/></div> : formatDate(GlobalVariables.lastTransactionDate)}</span>
            <JsonUploadForm />
        </div>
    );
};

export default UploadContent;